import { userhierarchyforall } from "../../js/api/users.js";
import {
  gettotalagents,
} from "../../js/api/getAgents.js";
import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";
let userData;
let MyBetsUsers = {
  startDate: '',
  endDate: '',
  currency: '',

  render: async () => {
    if (localStorage.getItem('my-bets_user-data')) {
      const _userData = localStorage.getItem('my-bets_user-data');
      userData = JSON.parse(_userData);
      localStorage.removeItem('my-bets_user-data');
      console.log(userData);
    }

    let role = localStorage.getItem("role");

    let userCoins = [];
    let userCoinsView = ``;

    if (localStorage.getItem("coins")) {
      userCoins = JSON.parse(localStorage.getItem("coins"));

      userCoins.forEach((coin) => {
        userCoinsView += `<option value="${coin.id}" ${userData && userData.currency === coin.id.toString() ? 'selected' : ''}>${_t('Monedha')}: ${Utils.currencyCode(coin.currency)}</option>`;
      });
    }
    

    if (role == "User") window.location.href = "/";

    let view =  `<div class="myBetsWrapper">
            <div class="myBetsHeader">
              <a class="backBtn">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"/></svg>
              </a>
              <span>${_t('Bastet e mia')}</span>
           </div>
            <div class="newMyBetsFilter">
              <input type="text" readonly  class="form-control" id="myCalendar">
              <button type="button" class="btn-filter">${_t('Filtro')}</button>
            </div>

            <div class="my-bets-tabs" id="predefinedRanges">
            </div>

            <div class="my-bets-select-filters" ${role === 'User' ? 'hidden' : ''}>
              <select name="accountAgentSelect" id="myBetsUsersUserCoinSelect" placeholder="${_t('Monedha')}" ${role == "User" || role == "Agent" ? "hidden" : ""}>
                  ${userCoinsView}
              </select>
            </div>
           
            <div class="usersContent">
               <div class="myBalanceTable">
                   <div class="myBalanceTableHeader2" hidden>
                       <span style="width:25%">${_t('Përdoruesi')}</span>
                       <span style="width:27%; text-align: right;">${_t('Shuma')}</span>
                       <span style="width:26%; text-align: right;">${_t('Fituese')}</span>
                       <span style="width:22%">${_t('Deferenca')}</span>
                    </div>
                    <div id="myAgents"></div>
               </div>
           </div>
           </div>
       `
    return view
  }
  , after_render: async () => {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = today.getFullYear();

    let months = [
      _t("Janar"),
      _t("Shkurt"),
      _t("Mars"),
      _t("Prill"),
      _t("Maj"),
      _t("Qershor"),
      _t("Korrik"),
      _t("Gusht"),
      _t("Shtator"),
      _t("Tetor"),
      _t("Nentor"),
      _t("Dhjetor"),
    ];
    let currentMonthDescription = `${months[today.getMonth()]}`;

    let ranges = {};
    ranges[_t('Sot')] = [moment(), moment()];
    ranges[_t('Dje')] = [moment().subtract(1, "days"), moment().subtract(1, "days")];
    ranges = {
      ...ranges,
      2023: [moment().startOf('year'), moment().endOf('year')],
      2022: [moment().subtract(1, "year").startOf('year'), moment().subtract(1, 'year').endOf('year')],
    };

    ranges[`${currentMonthDescription}`] = [
      moment().startOf("month"),
      moment().endOf("month"),
    ];
    ranges[`${months[today.getMonth() == 0 ? 11 : today.getMonth() - 1]}`] = [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ];

    today = yyyy + "-" + mm + "-" + dd;

    const startFromStore = userData ? userData.startDate : localStorage.getItem("betsStartDate");
    const endFromStore = userData ? userData.endDate : localStorage.getItem("betsEndDate");
    const start = startFromStore && startFromStore !== 'Invalid date' ? moment(startFromStore, 'YYYY-MM-DD').startOf("day") : moment().startOf("day");
    const end = endFromStore && endFromStore !== 'Invalid date' ? moment(endFromStore, 'YYYY-MM-DD').endOf("day") : moment().endOf("day");

    MyBetsUsers.startDate = start.format('YYYY-MM-DD');
    MyBetsUsers.endDate = end.format('YYYY-MM-DD');
    MyBetsUsers.currency = $("#myBetsUsersUserCoinSelect").val();

    let agents = await gettotalagents(
      MyBetsUsers.startDate,
      MyBetsUsers.endDate,
      MyBetsUsers.currency,
      userData ? userData.userId : null,
      userData ? userData.role : null
    );

    const agentsView = renderAgents(agents);
    document.getElementById("myAgents").innerHTML = agentsView;
    saveMetaData();

    let totalBet = 0;
    $("body .wonCoefItem").each(function () {
      totalBet += parseFloat(
        $(this).text().substring($(this).text().length, -1)
      );
    });

    
    async function datePickerCallback(start, end, label) {
      $("#contentLoader").append(
        '<div class="loaderWrapper">\n' +
          '            <div class="loader"></div>\n' +
          "        </div>"
      );
      let startDate = start.format("YYYY-MM-DD");
      let endDate = end.format("YYYY-MM-DD");

      MyBetsUsers.startDate = startDate;
      MyBetsUsers.endDate = endDate;

      agents = await gettotalagents(
        MyBetsUsers.startDate,
        MyBetsUsers.endDate,
        MyBetsUsers.currency,
        userData ? userData.userId : null,
        userData ? userData.role : null
      );
      const agentsView = renderAgents(agents);
      document.getElementById("myAgents").innerHTML = agentsView;

      $("body .loaderWrapper").remove();
      saveMetaData();
    }

    console.log(MyBetsUsers.startDate, MyBetsUsers.endDate);
    $("#myCalendar").daterangepicker(
      {
        // ranges: ranges,
        alwaysShowCalendars: true,
        startDate: start,
        endDate: end,
        opens: "center",
        linkedCalendars: false, // This prevents showing two months
        showCustomRangeLabel: false, 
      },
      datePickerCallback
    );

    const todayKey = _t('Sot');
    Object.keys(ranges).forEach(key => {
      $('#predefinedRanges').append(`<div class="my-bets-tabs__item ${key === todayKey ? 'active' : ''}" data-value="${key}">${key}</div>`)
    });

    $('body #predefinedRanges .my-bets-tabs__item').unbind('click');
    $("body").on("click", "#predefinedRanges .my-bets-tabs__item", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      // if ($(this).hasClass('active')) {
      //   return;
      // }
      const key = $(this).attr('data-value');
      if (ranges[key] !== undefined) {
        const range = ranges[key];
        if (range && range.length === 2) {
          $('#myCalendar').data('daterangepicker').setStartDate(range[0]);
          $('#myCalendar').data('daterangepicker').setEndDate(range[1]);
          datePickerCallback(range[0], range[1]);
        }
      }

      $('#predefinedRanges .my-bets-tabs__item.active').removeClass('active');
      $(this).addClass('active');
    });

    $("body").on("change", "#myBetsUsersUserCoinSelect", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      MyBetsUsers.currency = $("#myBetsUsersUserCoinSelect").val();
      const agents = await gettotalagents(
        MyBetsUsers.startDate,
        MyBetsUsers.endDate,
        MyBetsUsers.currency
      );
      const agentsView = renderAgents(agents);
      document.getElementById("myAgents").innerHTML = agentsView;
      saveMetaData();
    });

    $("body").on("click", ".expandRowList-mybets", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if ($(e.currentTarget).attr('href')) {
        window.location.href = $(e.currentTarget).attr('href');
        return;
      }
      if ($(e.currentTarget).parent().hasClass("expandNow")) {
        $(e.currentTarget).parent().removeClass("expandNow");
        $(e.currentTarget).siblings(".userHierarchyWrapper").remove();
      } else {
        let userId = $(e.currentTarget).attr("target-id");
        let roleName = $(e.currentTarget).attr("target-role");
        let childrenUser = await userhierarchyforall(userId);
        let childrenUserArray = childrenUser.data.children_users;

        const data = {
          startDate: MyBetsUsers.startDate,
          endDate: MyBetsUsers.endDate,
          currency: MyBetsUsers.currency,
          userId: userId,
          role: roleName,
          parent: userData
        }
        localStorage.setItem('my-bets_user-data', JSON.stringify(data));
        window.location.href = `#/mybetsusers/${userId}`;
        return;
        

        let agents = await gettotalagents(
          MyBetsUsers.startDate,
          MyBetsUsers.endDate,
          MyBetsUsers.currency,
          userId,
          roleName
        );
        console.log('Agents: ', agents);
        if (childrenUserArray.length !== 0) {
          let agentsView = renderAgents(agents);
          $(e.currentTarget)
            .parent()
            .append(`<div class="userHierarchyWrapper">${agentsView}</div>`);
          $(e.currentTarget).parent().addClass("expandNow");
        }
      }
    });


    $('body .backBtn').unbind('click');
    $('body .backBtn').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (userData && userData.parent) {
        localStorage.setItem('my-bets_user-data', JSON.stringify(userData.parent));
        window.history.back();
      } else if (userData) {
        window.location.replace('#/mybetsusers');
        window.location.reload();
      } else {
        window.location.replace('./#');
      }
    })
  },
  hideFooterCasino: true
};

function saveMetaData() {
  localStorage.setItem("currencySelected", $("#myBetsUsersUserCoinSelect").val());
  localStorage.setItem("betsStartDate", MyBetsUsers.startDate);
  localStorage.setItem("betsEndDate", MyBetsUsers.endDate);
}

function renderAgents(agents) {
  if (agents) {
    let agentsView = ``;
    agents.forEach((agent) => {
      agentsView += ` <a ${agent?.role_id === '4' ? `href="#/mybetsuserdetails/${agent.user_id}"` : ''} class="mybets-user-item expandRowList expandRowList-mybets" target-id="${agent.user_id}" target-role="${getRoleNameById(agent.role_id)}">
          <span>${agent.agent} (${agent.bets})</span>
          <span>${parseFloat(agent.return).toFixed(2)} </span>
      </a>`;

      // agentsView += `
      //   <div  class="myBalanceTableRow2 visible ${getRoleNameById(agent.role_id)}">
      //     <a class="expandRowList" target-id="${agent.user_id}" target-role="${getRoleNameById(agent.role_id)}">
      //         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none">
      //             <path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path>
      //         </svg>
      //     </a>
      //     <a class="userRowLink" style="width: calc(100% - 40px)" ${agent?.role_id === '4' ? `href="#/mybetsuserdetails/${agent.user_id}"` : ''}>
      //       <span style="width: 21%">${agent.agent}</span>
      //       <span style="width: 27%; text-align: right;">(${agent.bets}) ${parseFloat(agent.stake).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
      //       <span style="width: 27%; text-align: right;">(${agent.won_bets || '0'}) ${parseFloat(agent.poss_win).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
      //       <span style="width: 25%; text-align: right;">${parseFloat(agent.return).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
      //     </a>
      //   </div>
      // `;
    });
    return agentsView;
  } else {
    return _t('No users found! Please try again later.')
  }
}

function getRoleNameById(role_id) {
  switch(role_id) {
    case '1':
      return 'Administrator';
    case '2':
      return 'Supermanager';
    case '3':
      return 'Manager';
    case '4':
      return 'Agent';
    default:
      return 'User'
  }
}

export default MyBetsUsers;